<template>
  <div ref="main" :style="divStyle"></div>
</template>

<script>
import echarts from 'echarts';
import shine from '@/theme/shine.json';
echarts.registerTheme('shine', shine);

export default {
  props: ['option', 'divStyle', 'notMerge'],
  mounted() {
    this.$nextTick(() => {
      this.chart = echarts.init(this.$refs.main, 'shine');
      if (this.option) {
        this.chart.clear();
        this.chart.setOption(this.option);
      }
    });
  },
  watch: {
    option: {
      handler(val) {
        if (!val) return;
        this.chart.clear();
        this.chart.setOption(val, this.notMerge);
      },
      deep: true
    }
  }
};
</script>
